const state = {
  latestListings: false,
  topListings: true,
  filtersChips: true,
  showLatestCountersForTweets: false
}

const mutations = {
  setLatestListings (state, payload) {
    if (typeof payload === 'boolean') {
      state.latestListings = payload
    }
  },
  setTopListings (state, payload) {
    if (typeof payload === 'boolean') {
      state.topListings = payload
    }
  },
  setFiltersChips (state, payload) {
    if (typeof payload === 'boolean') {
      state.filtersChips = payload
    }
  },
  setShowLatestCountersForTweets (state, payload) {
    if (typeof payload === 'boolean') {
      state.showLatestCountersForTweets = payload
    }
  }
}

const actions = {}

const getters = {
  getLatestListings (state) {
    return state.latestListings
  },
  getTopListings (state) {
    return state.topListings
  },
  getFiltersChips (state) {
    return state.filtersChips
  },
  getShowLatestCountersForTweets (state) {
    return state.showLatestCountersForTweets
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/toggles.js